<template>
  <div class="newindex">
    <div class="header">
      <!-- <span class="btn_study" @click="showJiaochengDialog">教程</span> -->
      <span class="btn_study" @click="Toast1('开发中')">教程</span>
      <router-link :to="{ path: '/jiaodian/search' }" class="item">
        <div class="btn_searchpage"><label>搜索</label></div>
      </router-link>
      <router-link :to="{ path: '/jiaodian/brand' }" class="item">
        <div class="btn_changepage">修改品牌</div>
      </router-link>
    </div>
    <swiper class="swiper-wrapper" ref="mySwiper" :options="swiperOption" v-if="banner.length > 0">
      <swiper-slide v-for="(item, index) in banner" :key="index" class="banner-img">
        <img v-if="item.type == 'we_chat' || item.type == 'details_img'" class="banner-img" :src="item.pic" alt=""
          @click.stop="goBanner(item)" />
        <div v-if="item.type == 'mini_program'" style="position: relative;width:100%;height:100%">
          <img class="banner-img" :src="item.pic" />
          <wx-open-launch-weapp :appid="item.app_id" :path="item.url"
            style="position: absolute;top: 0;left: 0;bottom: 0;right: 0;z-index:1;overflow: hidden">
            <script v-is="script" type="text/wxtag-template">
              <style v-is="style"></style>
              <div style="width:1000px;height:1000px;"></div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </swiper-slide>
    </swiper>
    <!-- <div class="menu">
      <router-link to="/clock" tag="div" class="nav_a">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico1.png"
        />
        <span>早晚安打卡</span>
      </router-link>
      <router-link
        to="/square"
        tag="div"
        class="nav_a"
        @click="Toast1('开发中')"
      >
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico2.png"
        />
        <span>人脉广场</span>
      </router-link>
      <wx-open-launch-weapp
        username="gh_71dc8139aba8"
        path="pages/index/index.html"
        class="nav_a"
        @error="handleErrorFn"
        @launch="handleLaunchFn"
      >
        <script type="text/wxtag-template">
          <style>
            .img{
              display: block;
              width: 60%;
              margin: 0 auto 6px;
            }
            .name{
              display: block;
              width: 100%;
              text-align: center;
              font-size: 12px;
              color: #333;
            }
          </style>
            <div>
              <img
                class="img"
                src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico5.png"
              />
              <span class="name">获客商城</span>
            </div>
        </script>
      </wx-open-launch-weapp>
     <wx-open-launch-weapp class="nav_a" @click="gopage">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico5.png"
        />
        <span>获客商城</span>
      </wx-open-launch-weapp> 
      <div class="nav_a" @click="gopage">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico6.png"
        />
        <span>魔镜</span>
      </div>
      <div class="nav_a" @click="Toast1('开发中')">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico3.png"
        />
        <span>引流好课</span>
      </div>
      <div class="nav_a" @click="Toast1('开发中')">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico4.png"
        />
        <span>热门好书</span>
      </div> 
    </div> -->
    <div class="menu2">
      <div :class="cid == 0 ? 'menu2_1 activeNav' : 'menu2_1'" @click="clickNavA(0)">
        首页
      </div>
      <div class="menu2_2">
        <div>
          <span @click="clickNavA('video')" :class="cid == 'video' ? 'activeNav' : ''">视频</span>
          <!-- <span
            v-if="laowangList.length == 1"
            v-for="(item, index) in laowangList"
            :key="index"
            :class="cid == 'laowang' ? 'activeNav' : ''"
            @click="clickNavA('laowang')"
            >{{ item.cat_title }}</span
          > -->
          <span v-if="brandList.length > 1" :class="cid == 'brand' ? 'activeNav' : ''"
            @click="clickNavA('brand')">我的品牌</span>
          <span v-if="brandList.length == 1" v-for="(item, index) in brandList" :key="index"
            :class="cid == 'brand' ? 'activeNav' : ''" @click="clickNavA('brand')">{{ item.title }}</span>
          <span v-for="(item, index) in navLst" :key="index" @click="clickNavA(item.pid)"
            :class="cid == item.pid ? 'activeNav' : ''" data-id="item.id">{{ item.cat_title }}</span>
        </div>
      </div>
      <div class="menu2_3">
        <router-link :to="{ path: '/jiaodian/brand' }" class="item">
          <img src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/addico.png" />
        </router-link>
      </div>
    </div>
    <!-- 老王说医美子分类 -->
    <div class="menu3" v-if="laowangList.length > 0 && cid == 'laowang'">
      <div class="menu3_1">
        <div>
          <span @click="clickNavB('009')" :class="bid == '009' ? 'activeNav2' : ''">全部</span>
          <span v-for="(item, index) in laowangItemList" :key="index" :class="bid == item.id ? 'activeNav2' : ''"
            @click="clickNavB(item.id)">{{ item.cat_title }}</span>
        </div>
      </div>
    </div>
    <div class="menu3" v-if="brandList.length > 1 && cid == 'brand'">
      <div class="menu3_1">
        <div>
          <span @click="clickNavB(0)" :class="bid == 0 ? 'activeNav2' : ''">全部</span>
          <span v-for="(item, index) in brandList" :key="index" :class="bid == item.pid ? 'activeNav2' : ''"
            @click="clickNavB(item.pid)">{{ item.title }}</span>
        </div>
      </div>
      <div class="editBtn">
        <router-link :to="{ path: '/jiaodian/brand/addBrand' }" class="item">编辑
        </router-link>
      </div>
    </div>
    <div class="content_list">
      <!-- 文本列表 -->
      <div class="content_1" v-if="textContent">
        <newlist :cid-list="cidList"></newlist>
        <div v-if="hasTextList" style="font-size: .24rem;color: #999999;text-align: center;padding: .2rem 0;">
          <div class="yindao" v-if="yindaoImg">
            <img src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_yindao1.png" width="100%" />
          </div>
          {{ adddataText }}
        </div>
      </div>
      <!-- 视频列表 -->
      <div class="content_1" v-if="videoContent">
        <ul class="videoUl">
          <li v-for="(item, index) in videolist" :key="index">
            <router-link :to="{ path: '/video/index?id=' + item.id }">
              <div class="videoImg">
                <img :src="item.video_cover" />
              </div>
              <div class="videoText">
                <div class="videoTitle">
                  {{ item.video_name }}
                </div>
                <div class="video_tag">
                  <span>#{{ item.cat_title }}</span>
                  <span>引流{{ item.visit }}次</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <div v-if="hasvideoList" style="font-size: .24rem;color: #999999;text-align: center;padding: .2rem 0;">
          {{ adddataText }}
        </div>
      </div>
    </div>
    <!-- 教程弹窗 -->
    <div class="jiaocheng dialog" v-if="jiaochengDialog">
      <div class="jiaocheng_content">
        <img src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_close.png" class="yz_close"
          @click="hideJiaochengDialog" />
        <div class="jc_title">常见问题</div>
        <div class="jc_li">1.这是什么平台，有什么用？</div>
        <div class="jc_li">1.这是什么平台，有什么用？</div>
      </div>
    </div>
    <div style="height: 1.5rem;"></div>
    <span class="addText"><img
        src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_icoedit.png" /><router-link
        :to="{ path: '/jiaodian/addarticle' }">添加文章</router-link></span>

    <van-overlay :show="overlay_show">
      <div class="overlay_wrapper">
        <swiper class="swiper-wrapper1" ref="mySwiper1" :options="swiperOption">
          <swiper-slide v-for="(item, index) in pop" :key="index" class="banner-img1">
            <!-- <img class="banner-img1" :src="item.pic" alt="" @click.stop="goShareActivity(item)" /> -->
            <img v-if="item.type == 'we_chat' || item.type == 'details_img'" class="banner-img1" :src="item.pic" alt=""
              @click.stop="goBanner(item)" />
            <div v-if="item.type == 'mini_program'" style="position: relative;width:100%;height:100%">
              <img class="banner-img1" :src="item.pic" />
              <wx-open-launch-weapp :appid="item.app_id" :path="item.url"
                style="position: absolute;top: 0;left: 0;bottom: 0;right: 0;z-index:1;overflow: hidden">
                <script v-is="script" type="text/wxtag-template">
              <style v-is="style"></style>
              <div style="width:1000px;height:1000px;"></div>
            </script>
              </wx-open-launch-weapp>
            </div>
          </swiper-slide>
        </swiper>
        <img class="overlay_close" src="@/assets/images/overlay-close.png" @click.stop="close_overlay" />

      </div>
    </van-overlay>
  </div>
</template>

<script src="https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js"></script>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@assets/css/newhomeindex.css";
import "@assets/css/newlist.css";
import "@assets/css/swiper.min.css";
import { Toast, Dialog, Overlay } from "vant";
// import GoodList from "@components/GoodList";
// import PromotionGood from "@components/PromotionGood";
// import CouponWindow from "@components/CouponWindow";
import newlist from "@components/newlist";
import {
  getShare,
  follow,
  getFollowLstNew,
  getArticleListNew,
  getBrandListNew,
  getVideoListNew,
  getChildCategoryList,
  getIndexArticle,
  getIndex,
} from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
import wx from "weixin-js-sdk";
import { getBannerPop } from "@/api/lcapi";
import { getWechatConfig } from "@api/public";
import { getShareActivity } from "@/api/public";
export default {
  name: "Index",
  components: {
    newlist,
    [Dialog.name]: Dialog,
    swiper,
    swiperSlide,
    [Overlay.name]: Overlay,
    // GoodList,
    // PromotionGood,
    // CouponWindow
  },
  props: {},
  data: function() {
    let that = this;
    return {
      pop: [],
      swiperOption: {
        loop: true,
        autoplay: true, // 是否自动播放
        on: {
          slideChangeTransitionEnd: function() {
            // 处理手动操作轮播图后后不再自动轮播
            this.autoplay.start();
          },
        },
      },
      overlay_show: false,
      yindaoImg: false,
      hasTextList: false,
      hasvideoList: false,
      adddataText: "...",
      activeName: "1",
      jiaochengDialog: false,
      textContent: true,
      videoContent: false,
      navLst: [],
      laowangList: [], //老王说医美-列表
      laowangItemList: [], //老王医美子分类
      brandList: [], //子分类
      cid: 0, // 存储对应的行业id,默认首页为0
      bid: 0, //默认为0，显示我的品牌下的所有,009显示老王说医美子分类
      page: 1,
      // checkedCid: 0, //选中的cid,默认首页为0
      cidList: [], //行业cid对应的列表
      videolist: [], //视频列表
      finished: true,
      urlIndex: 0,
      isadd: true, //是否还需要加载
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      mapKey: "",
      banner: [],
      share_poster: "",
      share_poster_details: "",
      overlist: [],
    };
  },
  created() {},
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log("val:", val);
        console.log("oldVal:", oldVal);
        this.finished = true;
        this.page = 1;
        if (val.fullPath == "/?index=1") {
          //激活了底部视频
          this.urlIndex = 1;
          this.videolist = [];
        } else {
          //激活首页
          this.urlIndex = 0;
          this.cidList = [];
          this.textContent = true;
          this.videoContent = false;
        }
        this.getFollowLstNew();
        this.getFollow();
      },
      // 深度观察监听
      deep: true,
    },
  },

  mounted: function() {
    this.getBannerPop();
    let is_open = window.sessionStorage.getItem("is_open");
    if (!is_open) {
      this.getShareActivity();
    }
    getWechatConfig().then((data) => {
      console.log(data.data);
      wx.config({
        debug: false,
        appId: data.data.appId,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "translateVoice",
          "startRecord",
          "stopRecord",
          "onRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "uploadVoice",
          "downloadVoice",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "getNetworkType",
          "openLocation",
          "getLocation",
          "hideOptionMenu",
          "showOptionMenu",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "addCard",
          "chooseCard",
          "openCard",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
      wx.ready(function() {
        //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });
      wx.error(function() {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
    this.urlIndex = this.$route.query.index;
    this.getFollowLstNew();
    this.getFollow();
    this.getIndex();
    let that = this;
    window.addEventListener("scroll", that.scrollBottom);
  },
  methods: {
    getBannerPop() {
      getBannerPop().then((res) => {
        console.log("22442424");
        this.banner = res.data.banner;
        this.pop = res.data.pop;
      });
    },
    getShareActivity() {
      getShareActivity().then((res) => {
        this.overlist = res.data;
        this.overlay_show = true;
      });
    },
    close_overlay() {
      this.overlay_show = false;
      window.sessionStorage.setItem("is_open", true);
    },
    goShareActivity(item) {
      this.$router.push({
        path: "/shareActivity",
        query: { url: item.details_img_url },
      });
      this.close_overlay();
    },
    goBanner(e) {
      console.log(e);
      if(e.type == 'we_chat'){
        window.location.href = e.wap_url;
      }
      if(e.type == 'details_img'){
        this.$router.push({
        path: "/shareActivity",
        query: { url: e.details_img_url },
      });
      this.close_overlay();
      }
      // this.$router.push({
      //   path: e.wap_url,
      // });
    },
    getIndex() {
      getIndex().then((res) => {
        // this.banner = res.data.banner;
      });
    },
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    handleLaunchFn() {
      console.log("success");
    },
    Toast1(txt) {
      Toast(txt);
    },
    getFollowLstNew() {
      getFollowLstNew().then((res) => {
        if (res.data.cate.length == 0 && res.data.brand.length == 0) {
          Dialog.alert({
            message: "您还没有关注的行业和品牌！请务必先去关注一波~",
            theme: "round-button",
          }).then(() => {
            // on close
            window.location.href = "/jiaodian/brand";
          });
        }
        this.navLst = res.data.cate;
        this.brandList = res.data.brand;
        this.laowangList = res.data.laowang;
        this.yindaoImg = false;
        if (this.urlIndex == 1) {
          //表示需要初始渲染视频模块
          this.textContent = false;
          this.videoContent = true;
          this.cid = "video"; //初始默认cid为0,显示首页全部行业的数据
          this.hasTextList = false;
          this.adddataText = "";
          this.hasvideoList = false;
          this.getVideoListNew();
        } else {
          this.cid = 0; //初始默认cid为0,显示首页全部行业的数据
          this.hasTextList = false;
          this.adddataText = "";
          this.getArticleList();
        }
      });
    },
    getVideoListNew() {
      if (this.finished) {
        this.finished = false;
        var data = "?page=" + this.page + "&limit=12";
        getVideoListNew(data)
          .then((res) => {
            console.log("初始获取视频");
            if (res.data.length <= 0) {
              this.finished = false;
              this.adddataText = "我是有底线的~";
              this.hasvideoList = true;
            } else {
              this.videolist = this.videolist.concat(res.data);
              if (res.data.length < 12) {
                this.finished = false;
                this.adddataText = "我是有底线的~";
                this.hasvideoList = true;
              } else {
                this.finished = true;
                this.adddataText = "数据加载中...";
                this.hasvideoList = true;
              }
            }
          })
          .catch(() => {
            this.finished = false;
          });
      }
    },
    // 行业列表
    getArticleList() {
      if (this.finished) {
        this.finished = false;
        var data = this.cid + "?page=" + this.page + "&limit=10";
        getArticleListNew(data)
          .then((res) => {
            console.log("获取相应列表1：", res);
            if (res.data.length <= 0) {
              this.finished = false;
              this.hasTextList = true;
              this.adddataText = "我是有底线的~";
            } else {
              this.cidList = this.cidList.concat(res.data);
              if (res.data.length < 10) {
                this.finished = false;
                this.hasTextList = true;
                this.adddataText = "我是有底线的~";
              } else {
                this.hasTextList = true;
                this.adddataText = "数据加载中...";
                this.finished = true;
              }
            }
          })
          .catch(() => {
            this.finished = false;
          });
      }
    },
    clickNavA(e) {
      console.log("cid:", e);
      this.cid = e;
      this.page = 1;
      this.finished = true;
      this.cidList = [];
      this.videolist = [];
      this.yindaoImg = false;
      if (e == "brand") {
        //表示用户点击的是’我的品牌‘,此时bid默认为0，显示品牌列表
        this.bid = 0;
        this.textContent = true;
        this.videoContent = false;
        this.getBrandListNew();
      } else if (e == "laowang") {
        //表示用户点击的是’老王说医美‘,此时bid默认为009，显示老王说医美子分类列表
        this.textContent = true;
        this.videoContent = false;
        this.bid = "009";
        this.getLaowangListNew();
        this.getIndexArticle();
      } else if (e == "video") {
        //点击的视频
        window.location.href = "/?index=1";
        this.textContent = false;
        this.videoContent = true;
        this.getVideoListNew();
      } else {
        this.textContent = true;
        this.videoContent = false;
        this.getArticleList();
      }
    },
    // 老王说医美-列表
    getLaowangListNew() {
      console.log("this.laowangList[0].id：", this.laowangList[0].id);
      var data = "?id=" + this.laowangList[0].id;
      getChildCategoryList(data).then((res) => {
        console.log("获取老王说医美子分类");
        this.laowangItemList = this.laowangItemList.concat(res.data.child);
      });
    },
    // 老王医美子分类对应的列表
    getIndexArticle() {
      if (this.finished) {
        this.finished = false;
        var data = "?id=" + this.bid + "&page=" + this.page + "&limit=10";
        getIndexArticle(data)
          .then((res) => {
            console.log("获取相应老王说医美子分类的内容列表：", res);
            if (res.data.length <= 0) {
              this.finished = false;
              this.adddataText = "我是有底线的~";
              this.hasTextList = true;
              if (this.page == 1) {
                this.yindaoImg = true;
                this.adddataText = "";
              }
            } else {
              this.cidList = this.cidList.concat(res.data);
              if (res.data.length < 10) {
                this.finished = false;
                this.adddataText = "我是有底线的~";
                this.hasTextList = true;
              } else {
                this.finished = true;
                this.hasTextList = true;
                this.adddataText = "数据加载中...";
              }
            }
          })
          .catch(() => {
            this.finished = false;
          });
      }
    },
    // 品牌列表
    getBrandListNew() {
      if (this.finished) {
        this.finished = false;
        var data = this.bid + "?page=" + this.page + "&limit=10";
        getBrandListNew(data)
          .then((res) => {
            console.log("获取相应品牌文章列表：", res);
            if (res.data.length <= 0) {
              this.finished = false;
              this.adddataText = "我是有底线的~";
              this.hasTextList = true;
              if (this.page == 1) {
                this.yindaoImg = true;
                this.adddataText = "";
              }
            } else {
              this.cidList = this.cidList.concat(res.data);
              if (res.data.length < 10) {
                this.finished = false;
                this.adddataText = "我是有底线的~";
                this.hasTextList = true;
              } else {
                this.finished = true;
                this.hasTextList = true;
                this.adddataText = "数据加载中...";
              }
            }
          })
          .catch(() => {
            this.finished = false;
          });
      }
    },
    clickNavB(e) {
      console.log(e);
      this.bid = e;
      this.page = 1;
      this.cidList = [];
      this.finished = true;
      this.yindaoImg = false;
      if (this.cid == "brand") {
        this.getBrandListNew();
      }
      if (this.cid == "laowang") {
        this.getIndexArticle();
      }
    },
    // 显示教程
    showJiaochengDialog() {
      this.jiaochengDialog = true;
    },
    hideJiaochengDialog() {
      this.jiaochengDialog = false;
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    scrollBottom() {
      // console.log("桂东");
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      let bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 80;
      // console.log(scrollHeight);
      if (scrollTop != 0 && bottomOfWindow && this.finished == true) {
        this.page = this.page + 1;
        if (this.cid == "video") {
          this.getVideoListNew();
        } else if (this.cid == "brand") {
          this.getBrandListNew();
        } else {
          this.getArticleList();
        }
      }
    },
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({
          path: "/detail/" + item.id,
        });
      });
    },
    gopage() {
      window.location.href = "http://weixin.wedei.com/zt/mojing/index.aspx";
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then((res) => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
  },
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}

body,
html {
  background: #fff !important;
}

.index {
  background-color: #fff;
}

.index .follow {
  z-index: 100000;
}

.keep {
  text-align: center;
}

.yindao {
  width: 100%;
  margin: 0.4rem auto 0;
}

.banner-img {
  width: 100%;
  height: 3.75rem;
}

.swiper-wrapper {
  width: 100%;
  height: 3.75rem;
}

.overlay_wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overlay_top {
  position: relative;
  width: calc(100% - 2rem);
}

.overlay_top img {
  width: 100%;
}

.overlay_close {
  width: 1rem;
  height: 1rem;
  margin-top: 0.4rem;
}

.overlay_bottom {
  position: absolute;
  bottom: 0.6rem;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.overlay_title {
  font-size: 0.3rem;
  line-height: 0.46rem;
  background: linear-gradient(180deg, #ffffff 0%, #fff9da 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.overlay_hint {
  font-size: 0.48rem;
  font-weight: bold;
  line-height: 0.72rem;
  background: linear-gradient(180deg, #ffffff 0%, #fff9da 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 0.08rem;
}

.overlay_btn {
  width: 3rem;
  height: 0.84rem;
  background: linear-gradient(180deg, #fff4cc 0%, #ffc56f 100%);
  box-shadow: 2px 2px 0px 0px #e09e20;
  border-radius: 0.46rem;
  text-align: center;
  line-height: 0.84rem;
  color: #ff410a;
  font-size: 0.32rem;
  margin-top: 0.5rem;
}

.overlay_detail {
  width: calc(100% - 2rem);
}

.swiper-wrapper1 {
  width: calc(100% - 2rem);
  /* height: 5rem; */
}

.banner-img1 {
  width: 100%;
  /* height: 100%; */
}
</style>
